import { templateParse } from "../../logic/templateParse.js";
import { DataBaseComponent } from "./data-base-component.js";

export class DataClinksComponent extends DataBaseComponent {
    static webComponentName: string = "data-clinks";
    protected _templateId: string = "data-clinks-component";

    constructor() {
        super();
    }

    protected onConnected(): void {
        super.onConnected();
        this.on("click", `[role="add-link"]`, this.handleAddLink.bind(this));
        this.on("click", `[role="remove-link"]`, this.handleRemoveLink.bind(this));
        this.on("input", `[data-link-key-input]`, this.handleInputChange.bind(this));
        this.on("input", `[data-link-url-input]`, this.handleInputChange.bind(this));
    }
    protected setupSyncEventListeners(): void {
        // No sync events needed
    }
    protected render(): void {
        const mainData = this.addDataForTemplate();
        const mainHtml = templateParse(this.templateId, mainData);
        if (mainHtml) {
            this.innerHTML = mainHtml;
        }
        this.afterRender();
    }

    addDataForTemplate(): Record<string, any> {
        let linksData: Record<string, string> = {};

        if (this.value) {
            if (typeof this.value === 'object' && this.value !== null) {
                linksData = this.value as Record<string, string>;
            } else if (typeof this.value === 'string') {
                try {
                    linksData = JSON.parse(this.value);
                } catch (e) {
                    console.warn('DataClinksComponent: Invalid JSON in value', this.value);
                    linksData = {};
                }
            }
        }

        const linksArray = Object.entries(linksData).map(([key, url]) => ({
            key,
            url
        }));

        return {
            field: this.field,
            action: this.action,
            readonly: this.readOnly,
            linksData,
            linksArray
        };
    }
    public addLink(key:string,url:string): void {
        const currentLinks = this.getLinksFromValue();
        currentLinks[key] = url;

        this.updateValue(currentLinks);
        this.render();
    }
    private handleAddLink(event: Event): void {
        event.preventDefault();

        const keyInput = this.querySelector('[role="link-key-input"]') as HTMLInputElement;
        const urlInput = this.querySelector('[role="link-url-input"]') as HTMLInputElement;

        if (!keyInput || !urlInput) return;

        if (!keyInput.checkValidity() || !urlInput.checkValidity()) {
            keyInput.reportValidity();
            urlInput.reportValidity();
            return;
        }

        const key = keyInput.value.trim();
        const url = urlInput.value.trim();

        const currentLinks = this.getLinksFromValue();
        currentLinks[key] = url;

        this.updateValue(currentLinks);

        keyInput.value = '';
        urlInput.value = '';

        this.render();
    }

    private handleRemoveLink(event: Event): void {
        event.preventDefault();

        const button = event.target as HTMLButtonElement;
        const row = button.closest('[data-link-row]');
        if (!row) return;

        const container = this.querySelector('.links-container') ||
            this.querySelector('.existing-links');
        if (!container) return;

        const rows = container.querySelectorAll('[data-link-row]');
        const index = Array.from(rows).indexOf(row);

        if (index === -1) return;

        const currentLinks = this.getLinksFromValue();
        const keys = Object.keys(currentLinks);

        if (index >= 0 && index < keys.length) {
            const keyToRemove = keys[index];
            delete currentLinks[keyToRemove];
            this.updateValue(currentLinks);
            this.render();
        }
    }

    private handleInputChange(event: Event): void {
        const input = event.target as HTMLInputElement;
        const row = input.closest('[data-link-row]');
        if (!row) return;

        const keyInput = row.querySelector('[data-link-key-input]') as HTMLInputElement;
        const urlInput = row.querySelector('[data-link-url-input]') as HTMLInputElement;

        if (!keyInput || !urlInput) return;

        if (!keyInput.checkValidity() || !urlInput.checkValidity()) {
            return;
        }

        const container = this.querySelector('.links-container') ||
            this.querySelector('.existing-links');
        if (!container) return;

        const rows = container.querySelectorAll('[data-link-row]');
        const index = Array.from(rows).indexOf(row);

        if (index === -1) return;

        const newKey = keyInput.value.trim();
        const newUrl = urlInput.value.trim();

        if (!newKey || !newUrl) return;

        const currentLinks = this.getLinksFromValue();
        const keys = Object.keys(currentLinks);

        if (index >= 0 && index < keys.length) {
            const newLinks: Record<string, string> = {};
            keys.forEach((key, i) => {
                if (i === index) {
                    newLinks[newKey] = newUrl;
                } else {
                    newLinks[key] = currentLinks[key];
                }
            });

            this.updateValue(newLinks);
        }
    }

    private getLinksFromValue(): Record<string, string> {
        if (!this.value) return {};

        if (typeof this.value === 'object' && this.value !== null) {
            return { ...this.value as Record<string, string> };
        }

        if (typeof this.value === 'string') {
            try {
                return JSON.parse(this.value);
            } catch (e) {
                return {};
            }
        }

        return {};
    }

    private updateValue(links: Record<string, string>): void {
        this.value = links;

        this.dispatchEvent(new CustomEvent('form-change', {
            detail: { value: links },
            bubbles: true
        }));
    }
}